module.exports = {
  lang: {
    t1: `หน้าแรก`,
    t2: `บัตรนาม`,
    t3: `ติดตาม`,
    t4: `ผู้ติดต่อ`,
    t5: `ຂໍ້ຄວາມ`,
    t6: `ลงชื่อเข้าใช้`,
    t7: `ลงทะเบียน`,
    t8: `グローバルビジネス接続の新プラットフォーム、企業デジタルマーケティングの新領域`,
    t9: `WeMeet - เข้าสู่ระบบด้วยเบอร์โทรศัพท์มือถือ`,
    t10: `เบอร์โทรศัพท์มือถือ`,
    t11: `รหัสยืนยัน`,
    t12: `กรุณาใส่เบอร์โทรศัพท์มือถือ`,
    t13: `กรุณາใส่รหัสยืนยัน`,
    t14: `ได้รับ`,
    t15: `เข้าสู่ระบบ`,
    t16: `กรุณาใส่เบอร์โทรศัพท์มือถือในรูปแบบที่ถูกต้อง`,
    t17: `รหัสยืนยันถูกส่งแล้ว`,
    t18: `รหัสยืนยันที่ป้อนไม่ถูกต้อง โปรดตรวจสอบและป้อนใหม่`,
    t19: `ลงชื่อเข้าใช้เรียบร้อยแล้ว`,
    t20: `รหัสยืนยันของคุณคือ (0) กรุณาใช้ภายใน {1} นาที`,
    t21: `ยกเลิก`,
    t22: `ยืนยัน`,
    t23: `คำแนะนำ`,
    t24: `บัญชี WeMeet ของคุณยังไม่สมบูรณ์การลงทะเบียน ดำเนินการทันทีเพื่อเสร็จสิ้นขั้นตอนการลงทะเบียนและเพลิดเพลินไปกับการโต้ตอบและการใช้งานที่หลากหลายและไม่มีขีดจำกัด`,
    t25: `ไปยังการลงทะเบียน`,
    t26: `ล็อกอิน WeMeet ผ่านอีเมล`,
    t27: `ชื่อบัญชี`,
    t28: `โปรดป้อนอีเมลของคุณ`,
    t29: `รหัสผ่าน`,
    t30: `โปรดป้อนรหัสผ่านของคุณ`,
    t31: `ลืมรหัสผ่าน?`,
    t32: `ลงชื่อเข้าใช้`,
    t33: `วิธีการเข้าใช้งานอื่น ๆ`,
    t34: `ลงทะเบียน WeMeet小程序แล้วหรือไม่? ใช้งานเลย.`,
    t35: `ลงชื่อเข้าใช้ด้วยหมายเลขโทรศัพท์`,
    t36: `กรุณาใส่อีเมลของคุณก่อน`,
    t37: `กรุณาใส่รหัสผ่านของคุณก่อน`,
    t38: `รูปแบบอีเมลไม่ถูกต้อง`,
    t39: `หากคุณมีบัญชี WeMeet แล้ว คุณสามารถเข้าสู่ระบบโดยตรงได้`,
    t40: `ลงชื่อเข้าใช้`,
    t41: `รูปภาพโปรไฟล์`,
    t42: `โปรดอัปโหลดรูปภาพโปรไฟล์จริง`,
    t43: `ชื่อ-สกุล`,
    t44: `ชื่อ`,
    t45: `นามสกุล`,
    t46: `ชื่อหน่วยงาน`,
    t47: `โปรดระบุชื่อหน่วยงานของท่าน`,
    t48: `ตำแหน่ง`,
    t49: `โปรดระบุตำแหน่งงานของท่านในหน่วยงานนั้น`,
    t50: `อีเมล์`,
    t51: `โปรดป้อนอีเมลของคุณ`,
    t52: `เบอร์โทรศัพท์มือถือ`,
    t53: `กรุณาใส่เบอร์โทรศัพท์มือถือ`,
    t54: `ภูมิภาค`,
    t55: `โปรดเลือกภูมิภาค`,
    t56: `โซน`,
    t57: `โปรดเลือกจังหวัด,อำเภอ/เขต และแขวง`,
    t58: `ที่อยู่`,
    t59: `โปรดระบุที่อยู่ของท่าน`,
    t60: `我已閱讀並同意WeMeet的`,
    t61: `ข้อตกลงการใช้บริการ`,
    t62: `นโยบายความเป็นส่วนตัว`,
    t63: `ดำเนินการต่อ`,
    t64: `โปรด tích chọnข้อตกลงผู้ใช้ก่อน`,
    t65: `โปรดระบุชื่อของท่าน`,
    t66: `โปรดกรอกนามสกุลของคุณ`,
    t67: `โปรดกรอกอีเมล์ของคุณก่อน`,
    t68: `โปรดกรอกชื่อหน่วยงานของคุณก่อน`,
    t69: `รูปแบบอีเมลไม่ถูกต้อง`,
    t70: `ยกเลิก`,
    t71: `ทำเสร็จแล้ว`,
    t72: `ยืนยันหมายเลขโทรศัพท์มือถือ`,
    t73: `เบอร์โทรศัพท์มือถือ`,
    t74: `รหัสยืนยัน`,
    t75: `กรุณາใส่รหัสยืนยัน`,
    t76: `ได้รับ`,
    t77: `ข้ามการตรวจสอบ`,
    t78: `ยื่น`,
    t79: `ได้รับการยืนยันแล้ว`,
    t80: `รหัสยืนยันที่ป้อนไม่ถูกต้อง โปรดตรวจสอบและป้อนใหม่`,
    t81: `ข้ามไปแล้ว`,
    t82: `คำแนะนำ`,
    t83: `หมายเลขโทรศัพท์ที่คุณป้อนได้ลงทะเบียนกับบัญชี WeMeet แล้ว ไม่จำเป็นต้องลงทะเบียนซ้ำ กรุณาเข้าสู่ระบบเลย`,
    t84: `ไปที่หน้าเข้าสู่ระบบ`,
    t85: `คำแนะนำ`,
    t86: `ที่อยู่อีเมลที่คุณป้อนได้ลงทะเบียนกับบัญชี WeMeet แล้ว ไม่จำเป็นต้องลงทะเบียนซ้ำ กรุณาเข้าสู่ระบบเลย`,
    t87: `ไปที่หน้าเข้าสู่ระบบ`,
    t88: `ลิงก์ยืนยันการส่งแล้ว`,
    t89: `โปรดตรวจสอบอีเมลของคุณและคลิกบนลิงก์เพื่อเสร็จสิ้นการลงทะเบียน`,
    t90: `เข้าใจแล้ว`,
    t91: `ยินดีต้อนรับเข้าสู่ WeMeet`,
    t92: `ยินดีต้อนรับสู่ WeMeet! โปรดคลิกปุ่มเพื่อทำการลงทะเบียน เตือนเป็นมิตร: ลิงก์นี้มีอายุ 24 ชั่วโมง กรุณาดำเนินการโดยเร็วที่สุด`,
    t93: `ลงทะเบียนเรียบร้อย`,
    t94: `อีเมลของคุณถูก kích hoạtแล้ว โปรดใส่รหัสผ่านของคุณ`,
    t95: `ป้อนรหัสผ่าน`,
    t96: `โปรดป้อนรหัสผ่านของคุณ`,
    t97: `ยืนยันรหัสผ่าน`,
    t98: `โปรดกรอกรหัสผ่านอีกครั้ง`,
    t99: `ต้องประกอบด้วยตัวอักษรพิมพ์ใหญ่และตัวอักษรพิมพ์เล็ก ตัวเลข และอักขระพิเศษ ความยาวต้องอยู่ระหว่าง 8 ถึง 20 ตัวอักษร`,
    t100: `โปรดป้อนรหัสผ่านของคุณ`,
    t101: `โปรดกรอกรหัสผ่านอีกครั้ง`,
    t102: `รหัสผ่านไม่ตรงกัน`,
    t103: `ยินดีด้วย! คุณได้ทำการลงทะเบียนเสร็จเรียบร้อยแล้ว`,
    t104: `คุณได้เข้าสู่ระบบ WeMeet แล้ว ตอนนี้คุณสามารถดำเนินการต่อจากก่อนหน้านี้ได้`,
    t105: `ต่อไปนี้คุณจะได้สัมผัสประสบการณ์ของคุณ`,
    t106: `คำแนะนำ`,
    t107: `ลิงค์หมดอายุแล้ว โปรดคลิกที่ปุ่มเพื่อรับใหม่`,
    t108: `ส่งซ้ำ`,
    t109: `ข้อกำหนดการให้บริการ`,
    t110: `นโยบายความเป็นส่วนตัว`,
    t111: `รีเซ็ตรหัสผ่าน`,
    t112: `โปรดระบุบัญชีที่ต้องการรีเซ็ตรหัสผ่าน`,
    t113: `ชื่อบัญชี`,
    t114: `โปรดป้อนอีเมลของคุณ`,
    t115: `ยื่น`,
    t116: `กรุณาใส่อีเมลของคุณก่อน`,
    t117: `รูปแบบอีเมลไม่ถูกต้อง`,
    t118: `จดหมายถูกส่งแล้ว`,
    t119: `โปรดตรวจสอบอีเมลของคุณ คลิกที่ลิงก์ และรีเซ็ตรหัสผ่านของคุณ`,
    t120: `เข้าใจแล้ว`,
    t121: `รีเซ็ตรหัสผ่าน - WeMeet`,
    t122: `การร้องขอรีเซ็ตรหัสผ่านของคุณได้รับการยืนยัน และระบบได้สร้างลิงก์สำหรับรีเซ็ตรหัสผ่านชั่วคราวแล้ว เตือนเป็นมิตร: ลิงก์นี้มีอายุ 24 ชั่วโมง กรุณาดำเนินการโดยเร็วที่สุด`,
    t123: `รีเซ็ตรหัสผ่าน`,
    t124: `รีเซ็ตรหัสผ่านสำเร็จแล้ว`,
    t125: `คุณได้เข้าสู่ระบบ WeMeet แล้ว ยินดีต้อนรับกลับมา`,
    t126: `เข้าหน้าแรก`,
    t127: `ผู้ติดต่อ`,
    t128: `คำขอเพิ่มเพื่อนใหม่`,
    t129: `ยอมรับ`,
    t130: `ข้าม`,
    t131: `อนุมัติแล้ว`,
    t132: `ข้ามไปแล้ว`,
    t133: `ติดตาม`,
    t134: `ถูกติดตาม`,
    t135: `ຂໍ້ຄວາມ`,
    t136: `คำขอยังไม่ได้รับการตอบรับ`,
    t137: `โปรดป้อนชื่อหรือหมายเลขโทรศัพท์ของคุณ`,
    t138: `ไม่พบเนื้อหาที่ตรงกัน`,
    t139: `ไม่มีเพิ่มเติมแล้ว`,
    t140: `คำขอติดต่อ`,
    t141: `ยอมรับ`,
    t142: `ข้าม`,
    t143: `อนุมัติแล้ว`,
    t144: `ข้ามไปแล้ว`,
    t145: `พื้นที่ WeMeet AI`,
    t146: `กำลังติดตาม`,
    t147: `ยกเลิกการติดตามแล้ว`,
    t148: `vCard`,
    t149: `เชื่อมต่อ`,
    t150: `ส่งข้อความ`,
    t151: `รอการอนุมัติ`,
    t152: `ลบผู้ติดต่อ`,
    t153: `แนะนำตัวเอง`,
    t154: `ประวัติส่วนตัว`,
    t155: `คำแนะนำ`,
    t156: `คำขอติดต่อของคุณถูกส่งไปแล้ว หลังจากอนุมัติแล้วคุณจะติดตามเขา/เธอโดยอัตโนมัติ หรือคุณสามารถเลือกติดตามเขา/เธอในทันทีเพื่อเรียนรู้ข้อมูลเพิ่มเติมเกี่ยวกับเขาก่อนได้`,
    t157: `ยังไม่ติดตาม`,
    t158: `ติดตาม`,
    t159: `กำลังติดตาม`,
    t160: `ยกเลิกความสัมพันธ์ผู้ติดต่อ`,
    t161: `หลังยกเลิกความสัมพันธ์ผู้ติดต่อ ฝ่ายตรงข้ามจะไม่สามารถดูข้อมูลส่วนบุคคลของคุณได้อีก แต่จะไม่ยกเลิกการติดตามคุณพร้อมๆ กัน`,
    t162: `ลองคิดใหม่`,
    t163: `ลบผู้ติดต่อ`,
    t164: `ดำเนินการสำเร็จแล้ว`,
    t165: `AI ผู้ช่วย WeMeet`,
    t166: `กรุณาป้อนคำถามของคุณ`,
    t167: `ส่ง`,
    t168: `โปรดทราบว่าเนื้อหาการโต้ตอบกับ AI อาจไม่ถูกต้องและไม่ได้แสดงถึงมุมมองของแพลตฟอร์ม`,
    t169: `นามบัตร WeMeet`,
    t170: `ดาวน์โหลด`,
    t171: `แก้ไขนามบัตร`,
    t172: `ดาวน์โหลด二维玛`,
    t173: `รูปภาพถูกสร้างขึ้นแล้ว โปรดบันทึก สแกน二维玛เพื่อบันทึกข้อมูลผู้ติดต่อ`,
    t174: `รูปภาพโปรไฟล์`,
    t175: `โปรดอัปโหลดรูปภาพโปรไฟล์จริง`,
    t176: `ชื่อ-สกุล`,
    t177: `ชื่อ`,
    t178: `นามสกุล`,
    t179: `กรุณาป้อนชื่อของคุณ`,
    t180: `ชื่อหน่วยงาน`,
    t181: `โปรดระบุชื่อหน่วยงานของท่าน`,
    t182: `ตำแหน่ง`,
    t183: `โปรดระบุตำแหน่งงานของท่านในหน่วยงานนั้น`,
    t184: `อีเมล์`,
    t185: `โปรดป้อนอีเมลของคุณ`,
    t186: `เบอร์โทรศัพท์มือถือ`,
    t187: `กรุณาใส่เบอร์โทรศัพท์มือถือ`,
    t188: `ภูมิภาค`,
    t189: `โปรดเลือกภูมิภาค`,
    t190: `โซน`,
    t191: `โปรดเลือกจังหวัด,อำเภอ/เขต และแขวง`,
    t192: `ที่อยู่`,
    t193: `โปรดระบุที่อยู่ของท่าน`,
    t194: `โปรดระบุชื่อของท่าน`,
    t195: `โปรดกรอกนามสกุลของคุณ`,
    t196: `โปรดกรอกอีเมล์ของคุณก่อน`,
    t197: `โปรดกรอกชื่อหน่วยงานของคุณก่อน`,
    t198: `รูปแบบอีเมลไม่ถูกต้อง`,
    t199: `ห้องแชท`,
    t200: `แกลเลอรีรูปภาพ`,
    t201: `ถ่ายรูป`,
    t202: `กรุณาป้อนข้อความของคุณ`,
    t203: `ส่ง`,
    t204: `อ่านแล้ว`,
    t205: `ยังไม่อ่าน`,
    t206: `หมดเวลาในการยกเลิก`,
    t207: `ยกเลิก`,
    t208: `รูปภาพ (rûp-pîctûra)`,
    t209: `อัลบั้ม (albam)`,
    t210: `ถ่ายภาพ (thâi-pictûra)`,
    t211: `เลือกจากอัลบั้ม (lûak-kà-rɔ̂ɔk-albam)`,
    t212: `ยกเลิก`,
    t213: `รูปภาพ (rûp-pîctûra)`,
    t214: `ภาพ chân dung (pictûra-chân-dung)`,
    t215: `ดูตัวอย่าง (dû-tû-yāng)`,
    t216: `ทำเสร็จแล้ว`,
    t217: `พื้นที่ WeMeet AI`,
    t218: `ติดต่อเรา`,
    t219: `ติดต่อกับฉัน`,
    t220: `ชื่อ-สกุล`,
    t221: `องค์กร`,
    t222: `ตำแหน่ง`,
    t223: `โทรศัพท์`,
    t224: `อีเมล์`,
    t225: `ภูมิภาค`,
    t226: `โซน`,
    t227: `ที่อยู่`,
    t228: `โปรดระบุชื่อของคุณ`,
    t229: `โปรดกรอกชื่อหน่วยงานของคุณ`,
    t230: `โปรดกรอกตำแหน่งของคุณ`,
    t231: `กรุณาใส่หมายเลขโทรศัพท์ของคุณ`,
    t232: `โปรดกรอกที่อยู่อีเมลของคุณ`,
    t233: `โปรดเลือกภูมิภาค`,
    t234: `โปรดเลือกจังหวัด,อำเภอ/เขต และแขวง`,
    t235: `โปรดป้อนที่อยู่`,
    t236: `ความต้องการ`,
    t237: `ซื้อสินค้า`,
    t238: `สินค้าตัวแทนจำหน่าย`,
    t239: `ความร่วมมือทางตลาด`,
    t240: `อื่น ๆ`,
    t241: `โปรดระบุชื่อของคุณ`,
    t242: `โปรดกรอกชื่อหน่วยงานของคุณ`,
    t243: `โปรดกรอกที่อยู่อีเมลของคุณ`,
    t244: `รูปแบบอีเมลไม่ถูกต้อง`,
    t245: `ข้อความถูกส่งแล้ว`,
    t246: `ฝากข้อความ`,
    t247: `โปรดป้อนข้อมูลคำถามของคุณ`,
    t248: `ยืนยัน`,
    t249: `โปรดเข้าสู่ระบบหรือสมัครสมาชิกก่อน`,
    t250: `ผู้ติดตาม`,
    t251: `ติดต่อเรา`,
    t252: `ผลิตภัณฑ์`,
    t253: `ทีม`,
    t254: `ภาพรวม`,
    t255: `อัลบั้ม`,
    t256: `คุณสมบัติ`,
    t257: `ทุนจดทะเบียน`,
    t258: `วันก่อตั้ง`,
    t259: `ที่อยู่ตามทะเบียน`,
    t260: `thượng lưu`,
    t261: `กลางลำน้ำ`,
    t262: `hạ lưu`,
    t263: `Industri berkaitan`,
    t264: `กระบวนการ`,
    t265: `บันทึก`,
    t266: `ได้รับการยืนยัน`,
    t267: `จีน`,
    t268: `อังกฤษ`,
    t269: `ฝรั่งเศส`,
    t270: `รัสเซีย`,
    t271: `สเปน`,
    t272: `ญี่ปุ่น`,
    t273: `เกาหลี`,
    t274: `อินโดนีเซีย`,
    t275: `เวียดนาม`,
    t276: `เยอรมัน`,
    t277: `ตุรกี`,
    t278: `อิตาลี`,
    t279: `โปรตุเกส`,
    t280: `ไทย`,
    t281: `มาเลย์`,
    t282: `อาหรับ`,
    t283: `ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง`,
    t284: `กรุณาอ่านและยอมรับข้อตกลงการใช้งาน WeMeet ก่อน`,
    t285: `ไม่มีเนื้อหาที่เกี่ยวข้อง`,
    t286: `ประเภท`,
    t287: `คุณสมบัติ`,
    t288: `รายละเอียด`,
    t289: `อื่น ๆ`,
    t290: `ผลิตภัณฑ์ทั้งหมด 2 รายการ`,
    t291: `{1} เชิญคุณมาเยี่ยมชม WeMeet AI Space ของ {2}`,
    t292: `คลิกที่นี่เพื่อดูตัวอย่างหรือป้อนคำถาม:`,
    t293: `รีเฟรช`,
    t294: `คุณยังสามารถคลิกที่บัตรนามข้างล่างเพื่อเพิ่มข้อมูลติดต่อเพิ่มเติม:`,
    t295: `เรียนรู้`,
    t296: `การประชุมดิจิทัล WeMeet`,
    t297: `การแสดงแบบดิจิทัล WeMeet`,
    t298: `Cartão de visita e Espaço WeMeet AI`,
    t299: `วิธีการเป็นสมาชิกองค์กร WeMeet`,
    t300: `WeMeet บริการการประชุมดิจิตอลจะให้คุณด้วยการแก้ปัญหาการประชุมออนไลน์อย่างครอบคลุม ซึ่งรวมถึงการสร้างและเผยแพร่การประชุม การจัดการลงทะเบียนผู้เข้าร่วม การลงชื่อเข้าร่วมอิเล็กทรอนิกส์ การจัดกำหนดการประชุม การแบ่งปันเอกสารการประชุม การสนทนาแบบเรียลไทม์ และการจับคู่กับแขกอื่นๆ`,
    t301: `WeMeet นิทรรศการดิจิทัล ช่วยในการสร้างเว็บไซต์ทางการขนาดเล็กของนิทรรศการอย่างรวดเร็ว แสดงข้อมูลของผู้จัดแสดง คำอธิบายสินค้าที่จัดแสดง การถ่ายทอดสดของนิทรรศการ การลงทะเบียนนิทรรศการ กำหนดการกิจกรรม และอื่น ๆ เพื่อให้บริษัทผู้เข้าร่วมและผู้ชมเข้าใจรายละเอียดของนิทรรศการได้อย่างง่ายดาย ในการใช้ฟังก์ชัน WeMeet นิทรรศการดิจิทัล โปรดทำการเสร็จสิ้นกระบวนการเข้าร่วมสถาบันก่อน คลิกที่ "ของฉัน" ลากหน้าจอลงไปที่ "ศูนย์บริการ" - "การเข้าร่วมสถาบัน" และปฏิบัติตามคำแนะนำเพื่อทำการเข้าร่วม`,
    t302: `ผู้ใช้ส่วนบุคคลของ WeMeet เพียงแค่ให้สิทธิใน ID WeChat, เบอร์โทรศัพท์ และทำการลงทะเบียนในแพลตฟอร์มเพื่อรับบัตรนามสกุลดิจิทัลส่วนบุคคลและรักษาห้องพัก AI ส่วนบุคคลของตน (รวมถึงประวัติส่วนตัว, อัพเดท, รูปถ่าย, เอกสาร ฯลฯ)`,
    t303: `คลิกที่ "ของฉัน" บนแถบเมนูด้านล่างของมินิโปรแกรมเพื่ออัปเดตหน้าบัตรนามสกุลส่วนตัวและปรับปรุงหน้าแรกส่วนตัว`,
    t304: `การรวมตัวอักษรพิมพ์ใหญ่และพิมพ์เล็ก ตัวเลข และเครื่องหมายวรรคตอน ความยาวระหว่าง 8-20 ตัวอักษร`,
    t305: `ป้อนชื่อผลิตภัณฑ์`,
    t306: `ไม่มีอีก`,
    t307: `คลิกที่มุมขวาบน`,
    t308: `เลือกวิธีการแชร์ที่คุณชอบ`,
    t309: `ฉันเข้าใจแล้ว`,
    t310: `โปรดลงทะเบียนและเข้าสู่ระบบก่อน`,
    t311: `รับทราบข้อมูลเพิ่มเติม`,
    t312: `ผลิตภัณฑ์ที่เกี่ยวข้อง`,
    t313: `ขอบคุณสำหรับการเยี่ยมชม`,
    t314: `ออกจากระบบ`,
    t315: `องค์กรที่ติดตาม`,
    t316: `ก่อนหน้า`,
    t317: `ถัดไป`,
    t318: `ไม่มี`,
    t319: `{1}เชิญคุณมาเยี่ยมชม {2}`,
    t320: `ห้อง AI ยังไม่รักษาภาษาปัจจุบัน`,
    t321: `ห้อง AI ได้สลับไปยังภาษาปัจจุบัน`,
    t322: `ลิงก์ได้รับการเปิดใช้งาน`,
    t323: `เครือข่ายไม่ว่าง โปรดลองอีกครั้งในภายหลัง`,
    t324: `รายละเอียดผลิตภัณฑ์ได้ถูกเปลี่ยนเป็นภาษาปัจจุบันแล้ว`,
    t325: `รายละเอียดผลิตภัณฑ์ไม่ได้รับการบำรุงรักษาในภาษานี้ในปัจจุบัน`,
    t326: `สวัสดีค่ะ ฉันคือ WeMeet ผู้ช่วยปัญญาประดิษฐ์ พร้อมให้บริการที่ใส่ใจทุกเวลา! มีอะไรให้ฉันช่วยไหมคะ?`,
    t327: `ป้อนชื่อ`,
    t328: `ฉันพบข้อมูลการติดต่อที่เกี่ยวข้อง โปรดตรวจสอบบัตรติดต่อด้านล่าง`,
    t329: `ไฟล์แนบ`,
    t330: `ฉันไม่พบข้อมูลการติดต่อที่เกี่ยวข้อง`,
    t331: `ฉันได้ส่งคำถามของคุณไปยังเพื่อนร่วมงานที่รับผิดชอบด้านล่างนี้; คุณยังสามารถคลิกที่นามบัตรเพื่อติดต่อทันที`,
    t332: `นิทรรศการ`,
    t333: `กรุณาใส่`,
    t334: `ผู้ใช้`,
    t335: `ไม่มีอีก`,
    t336: `รีเฟรชสำเร็จ`,
    t337: `กำลังโหลด`,
    t338: `ปล่อยเพื่อรีเฟรช`,
  },
};

// 泰语
